import React, { forwardRef, TextareaHTMLAttributes } from 'react';
import { useId } from 'react-id-generator';
import { Label } from './Label';

export interface TextAreaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  labelClassname?: string;
  parentsClassname?: string;
  helper?: string;
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (
    {
      className = '',
      label,
      labelClassname = '',
      parentsClassname = '',
      helper,
      ...props
    },
    ref
  ) => {
    const [id] = useId(1, 'textarea');

    return (
      <div className={`label-col ${parentsClassname}`}>
        {label && (
          <Label htmlFor={id} text={label} className={labelClassname} />
        )}
        <textarea
          ref={ref}
          id={id}
          className={`textarea ${helper ? 'border-error' : ''} ${className}`}
          {...props}
        />
        {helper && <p className="text-sm text-error">{helper}</p>}
      </div>
    );
  }
);
